import type { SpatialRectangle } from "../types/spatial/SpatialRectangle"
import type { Measure } from "../types/Units"

export const BoxToRectangle = <T extends Measure>([x, y, x2, y2]: [
  T,
  T,
  T,
  T,
]): SpatialRectangle<T> => ({
  height: (y2 - y) as T,
  width: (x2 - x) as T,
  x,
  y,
})
